import Card from "../../components/PushNotifications/Card";
import ViewList from "../../components/Templates/ViewList";
import usePushNotificationsContainer from "../../containers/PushNotifications/usePushNotificationsContainer";
import { useContent } from "../../content/useContent";
import { Routes } from "../../routes/Routes";

const PushNotifications = () => {
  const {
    pushNotifications,
    pageLoading,
    page,
    handleChangePage,
    rowsPerPage,
    loading,
  } = usePushNotificationsContainer();

  const { pushNotifications: content } = useContent().pages;

  type IProps = {
    row: any;
  };
  const Row: React.FC<IProps> = ({ row }) => <Card row={row} />;

  return (
    <ViewList
      title={content.pushNotification}
      multiTitle={content.pushNotifications}
      pageLoading={pageLoading}
      rowsPerPage={rowsPerPage}
      page={page}
      rows={pushNotifications}
      handleChangePage={handleChangePage}
      Row={Row}
      addPath={Routes.addPushNotification}
      // Note: Required props in ViewList, will be properly used
      // when we implement the feature
      selected={false}
      handleDelete={() => null}
      openDeleteDialog={false}
      setOpenDeleteDialog={() => null}
      deleteLoading={loading}
    />
  );
};

export default PushNotifications;
